import dayjs from 'dayjs/esm';
import { ICbicContentMst } from 'app/entities/cbic-content-mst/cbic-content-mst.model';
import { ICbicDocMst } from 'app/entities/cbic-doc-mst/cbic-doc-mst.model';

export interface ICbicContentTypeMst {
  id?: number;
  isActive?: string | null;
  orderId?: number | null;
  createdDt?: dayjs.Dayjs | null;
  updatedDt?: dayjs.Dayjs | null; 
  createdBy?: number | null;
  updateBy?: number | null;
  versionNo?: number | null;
  parentId?: number | null;
  contentType?: string | null;
  titleEn?: string | null;
  titleHi?: string | null;
  infoEn?: string | null;
  infoHi?: string | null;
  path?: string | null;
  cbicContentMsts?: ICbicContentMst[] | null;
  cbicDocMsts?: ICbicDocMst[] | null;
}

export class CbicContentTypeMst implements ICbicContentTypeMst {
  constructor(
    public id?: number,
    public isActive?: string | null,
    public orderId?: number | null,
    public createdDt?: dayjs.Dayjs | null,
    public updatedDt?: dayjs.Dayjs | null,
    public createdBy?: number | null,
    public updateBy?: number | null,
    public versionNo?: number | null,
    public parentId?: number | null,
    public contentType?: string | null,
    public titleEn?: string | null,
    public titleHi?: string | null,
    public infoEn?: string | null,
    public infoHi?: string | null,
    public path?: string | null,
    public cbicContentMsts?: ICbicContentMst[] | null,
    public cbicDocMsts?: ICbicDocMst[] | null
  ) {}
}

export function getCbicContentTypeMstIdentifier(cbicContentTypeMst: ICbicContentTypeMst): number | undefined {
  return cbicContentTypeMst.id;
}
